// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3yTfh","rootCenter":"LoadMoreObserver_rootCenter__1ceA8","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__uwDMt"};